/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Watery_Proud_Bird_AttendInputs */

const en_watery_proud_bird_attend = /** @type {(inputs: Watery_Proud_Bird_AttendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fee`)
};

/**
* | output |
* | --- |
* | "Fee" |
*
* @param {Watery_Proud_Bird_AttendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const watery_proud_bird_attend = /** @type {((inputs?: Watery_Proud_Bird_AttendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Watery_Proud_Bird_AttendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_watery_proud_bird_attend(inputs)
});